import React,{Component} from 'react';
import { connect } from 'react-redux';
// utils
import {loadIfStateAvailableInSessionStorage,Translations} from '../../../../utils';
// constant
import { FORM_REFS } from '../../../../constants';

// restClient
import {eapiClient, aemHostClient} from '../../../../restClient';

// children
import  Dynamicform from '../../../common/Dynamicform/dynamicForm';
import NavListAccordion, {NavListAccordionWrapper} from '../../../common/NavListAccordion/NavListAccordion';

//action Creator
import {
  setAddresses,
  setCountryFormActiveTabIndex,
  reSetCountryFormActiveTabIndex
} from '../../actions/actionCreator';

class ItalyAccountSignatoryForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      signatoriesData:[],
      countryItalyForm:{
        signatoryDeclaration:[]
      },
      dataReady:false,
      methodFlag:false,
      id:'',
      lid:''
    };
    this.accountSignatoryId=[];
    this.setId ="";
  }

  translations = (text) => {
    return Translations(text,this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  loadPageState =()=>{
    var {caseId, productId} = this.props.match.params;

    eapiClient("/countryForms/case/" + caseId + "/product/" + productId)
    .then(({data}) => {
      this.setState({entityName:data.responseData.entityName})
      if(data.responseData.countryItalyForm !== undefined){

        this.setState({
          countryItalyForm:data.responseData.countryItalyForm,
          dataReady:true,
          methodFlag:true,
          status: data.responseData.countryItalyForm.signatoryDeclaration,
          remainingObj : data.responseData.countryItalyForm.signatoryDeclaration
        });
      }else  {
        this.setState({id:data.responseData.id, lid:data.responseData.lid,
          dataReady: true
        });
      }
    });

    eapiClient("/countryForms/case/" + caseId + "/country/Italy")
    .then(({data}) => {
      this.setState({ signatoriesData : data.responseData });
    });
  }

  componentWillMount() {
    var {caseId} = this.props.match.params;
    loadIfStateAvailableInSessionStorage(this, null, () => {
      this.loadPageState();
    });
    let apiURL = "/aemData/formData/json_italy-account-signatory-page";
    if (this.props.mode === "edit") {
      apiURL = apiURL.replace("json_add-", "json_edit-");
    }
    aemHostClient(apiURL)
    .then(({data}) => {
      this.setState({ formJson:data });
    });
    eapiClient("/addresses/case/" + caseId)
    .then(({data}) => {
      this.props.setAddresses(data.responseData);
    });
  }

  componentDidMount(){
    var getCurrentDropDown = window.sessionStorage.getItem("getCurrentDropDown");
    var getCurrentDropDownValue = window.sessionStorage.getItem('key'+ getCurrentDropDown);
    if(getCurrentDropDown !== null){
      var getCurrentDropDownIndex = getCurrentDropDown.split('personalHomeAddress')[1];
    }
    var _signatoryDeclaration = [...this.state.countryItalyForm.signatoryDeclaration];
    if(getCurrentDropDown === `personalHomeAddress${getCurrentDropDownIndex}`
      && getCurrentDropDownValue!== null){
        for(let pos in _signatoryDeclaration ){
          if(_signatoryDeclaration[pos].accountSignatoryId === getCurrentDropDownIndex){
            _signatoryDeclaration.personalHomeAddress = getCurrentDropDownValue;
          }
        }
        this.setState({
          countryItalyForm:{
            ...this.state.countryItalyForm,
            signatoryDeclaration: _signatoryDeclaration
          }
        });
      }
      window.sessionStorage.removeItem("getCurrentDropDown");
      window.sessionStorage.removeItem('key'+ getCurrentDropDown);
    }

  getFormData = (index, formData) => {
      let _signatoryDeclaration = [...this.state.countryItalyForm.signatoryDeclaration];
      let _remainingObj =[...this.state.remainingObj];
      if(formData.previouslySignedAccountSignatoryDeclarationForm === true){
       formData.countryOfCitizenship={value:'', name:''};
       formData.placeOfBirth = '';
       formData.sex='';
       formData.personalHomeAddress= '';
       formData.placeOfIssue='';
       formData.typeOfProvidedIdCard='';
       formData.documentIdNumber='';
       formData.signExpirationDate='';
       formData.personalResidense='';
       formData.fiscalCode='';
       formData.signDateOfIssue='';
    }

    _signatoryDeclaration[index] = formData;
    _remainingObj[index] = formData;

    this.setState({
      countryItalyForm:{...this.state.countryItalyForm, signatoryDeclaration: _signatoryDeclaration
      },
      remainingObj:_remainingObj
    });
    }

    saveForm = () =>{
      let apiURL;
      let payLoad={};
      let countryItalyForm ={};
      this.props.reSetCountryFormActiveTabIndex();
      var {caseId, productId} = this.props.match.params;
      payLoad.caseId = caseId;
      payLoad.productId=productId;
      payLoad.id = this.state.id0;
      payLoad.lid = this.state.lid;
      payLoad.countryFormName = "Italy Account Signatory Declaration Form";
      countryItalyForm.signatoryDeclaration =this.state.countryItalyForm.signatoryDeclaration;
      payLoad.countryItalyForm=countryItalyForm;

      apiURL = "/countryForms/case/" + caseId + "/product/" + productId
      eapiClient(apiURL,{
        method:"PUT",
        data: JSON.stringify(payLoad)
      })
        .then(({data}) => {
            this.props.history.goBack();
        })
    }
    onFormSubmit = (index) => {
      let apiURL;
      let payLoad={};
      let countryItalyForm ={};
      //let signatoryDeclaration =[];
      var {caseId, productId} = this.props.match.params;
      payLoad.caseId = caseId;
      payLoad.productId=productId;
      payLoad.id = this.state.id;
      payLoad.lid = this.state.lid;
      payLoad.countryFormName = "Italy Account Signatory Declaration Form";
      countryItalyForm.signatoryDeclaration = this.state.countryItalyForm.signatoryDeclaration.splice(index, 1);
      this.setId =   countryItalyForm.signatoryDeclaration[0].id;
      //this.remainingObj = this.state.countryItalyForm.signatoryDeclaration
      //countryItalyForm.signatoryDeclaration = this.state.countryItalyForm.signatoryDeclaration;
      payLoad.countryItalyForm=countryItalyForm;
      apiURL = "/countryForms/case/" + caseId + "/product/" + productId
      eapiClient(apiURL,{
        method:"PUT",
        data: JSON.stringify(payLoad)
      })

      .then(({data, status}) => {
        if(data.responseData.countryItalyForm !== undefined){

          let getFilterdata = data.responseData.countryItalyForm.signatoryDeclaration.map((item, index) =>{
            if(this.setId === item.id){
              return item;
            }
          }).filter(item => item !== undefined)[0]

          let updatedSignatorydata =  this.state.remainingObj.map((item,key) => {
            if(item.id === getFilterdata.id){
              item = getFilterdata
            }
            return item;
          });

          this.setState({
            countryItalyForm:{
              signatoryDeclaration: updatedSignatorydata
            },
            dataReady:true,
            methodFlag:true,
            status: data.responseData.countryItalyForm.signatoryDeclaration
          });
        }else  {
          this.setState({id:data.responseData.id, lid:data.responseData.lid,
            dataReady: true
          });
        }
      });
    }

    onFormCancel = () => {
      this.props.history.goBack();
    }

    renderFormGroups = (index) => {
      let formData={};
      let mode = "edit";

      if(this.state.countryItalyForm.signatoryDeclaration[index] !== undefined){
        formData = {...this.state.countryItalyForm.signatoryDeclaration[index]};
      }
      else {
        formData.accountSignatoryId = this.state.signatoriesData[index].id;
        formData.previouslySignedAccountSignatoryDeclarationForm = false;
      }
      const properties = {
        formData,
        editType: `{italy-account-signatory-form${index}}`,
        pathname: this.props.history.location.pathname
      };
      if (this.state.dataReady && this.state.formJson !== undefined && this.state.formJson.par.aemform_ !== undefined) {
        return (
          <Dynamicform mode={mode}
          properties={properties}
          url={FORM_REFS[this.state.formJson.par.aemform_.formRef]}
          getFormData={this.getFormData.bind(this, index)}
          onFormSubmit={this.onFormSubmit.bind(this, index)}
          hideButtons={true}
          saveButton={true}
          onFormCancel={this.onFormCancel}
          history={this.props.history}
          pageState={this.state}
          index={index}
          italyIndex={index}
          lang = {this.props.lang.currentLang.lang}
          translatedData ={this.props.lang.translatedData}
          flag={this.props.lang.currentLangFlag.flag}/>
        );
      }
    }

    getTabIndex = (index) => {
      this.props.setCountryFormActiveTabIndex(index);
    }

    render() {
      let navAccordionRenderJsx=[];
      let _signatoriesData = this.state.countryItalyForm.signatoryDeclaration;
      let buttonJsx;
      buttonJsx =(<h3>Loading.....</h3>);
      if(this.state.formJson){
        buttonJsx =(<div>
          <button onClick={this.saveForm} aria-label={this.state.formJson.par.button_save.text} className="gdocs-btn-submit"> {this.translations(this.state.formJson.par.button_save.text)}</button>
          </div>);
        }

        for(let i =0; _signatoriesData.length > i; i++){
          navAccordionRenderJsx.push(
            <NavListAccordion
            lang={this.props.lang.currentLang.lang}
            navAccHeading={`${this.state.countryItalyForm.signatoryDeclaration[i].firstName !== undefined ? this.state.countryItalyForm.signatoryDeclaration[i].firstName :''}
                 ${this.state.countryItalyForm.signatoryDeclaration[i].lastName !== undefined ? this.state.countryItalyForm.signatoryDeclaration[i].lastName :''}
                 ${this.state.countryItalyForm.signatoryDeclaration[i].dateOfBirth !== undefined ? ',' :''}
                 ${this.state.countryItalyForm.signatoryDeclaration[i].dateOfBirth !== undefined ? this.state.countryItalyForm.signatoryDeclaration[i].dateOfBirth :''}`}
                 status= {this.state.status[i].status !== undefined ? this.state.status[i].status :'incomplete'}
                 _onClick={this.getTabIndex.bind(this, `${i}`)}
              >
              <div className="basic-details-section">{this.renderFormGroups(i)}</div>
              </NavListAccordion>
            )
          }

          const pageTitle = this.state.formJson ? this.state.formJson.par.page_title_mainTitle : {};
          return ((this.state.dataReady) ?
          <div className="form-container">
          <div className="gdocs-poland-country-form-container">
          <div className="pannel-heading-container">
          <h1 className="form-heading">{this.translations(pageTitle.pageHeading)}</h1>
          <div className="gdocs-clear-float"></div>
          <p className="pannel-sub-heading">{this.state.entityName}</p>
          <p className="form-required-desc optional-text">{this.translations(pageTitle.descriptionText)}</p>
          </div>
          <div className="gdocs-clear-float"></div>
          <NavListAccordionWrapper open={this.props.displayTabIndex}>
          {navAccordionRenderJsx}
          </NavListAccordionWrapper>
          <div key="buttons-wrapper" className="form-buttons-section save-btn-top-border">
          <div className="form-buttons-wrapper">
          {buttonJsx}
          </div>
          </div>
          </div>
          </div>
          :'');
        }
      }

      const mapStateToProps = state => {
        return {
          addresses: state.addressess,
          displayTabIndex: state.countryFormInfo.activeTabIndex,
          lang:state.lang
        }
      }

      const mapDispatchToProps = dispatch => {
        return {
          setAddresses: addresses => {
            dispatch(setAddresses(addresses));
          },
          setCountryFormActiveTabIndex: index => {
            dispatch(setCountryFormActiveTabIndex(index))
          },
          reSetCountryFormActiveTabIndex: () => {
            dispatch(reSetCountryFormActiveTabIndex())
          }
        }
      }
      export default connect(mapStateToProps,mapDispatchToProps)(ItalyAccountSignatoryForm);



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CountryForms/ItalyAccountSignatoryForm.js